import { type ModalProps, Modal as MuiModal } from '@mui/base'
import { clsx } from 'clsx'
import { type JSX } from 'react'

import { ModalBackdrop } from './ModalBackdrop'

export { type ModalProps } from '@mui/base'

/**
 * The Modal component lets you create dialogs, drawers, popovers, lightboxes, and other elements that force the user to take action before continuing.
 */
export const Modal = (props: ModalProps): JSX.Element => {
  const { className, slots, ...other } = props

  return (
    <MuiModal
      {...other}
      className={clsx('modal', className)}
      slots={{
        backdrop: ModalBackdrop,
        ...slots,
      }}
    />
  )
}
